/* eslint-disable */

export const postsReducerInitialState = {
    posts: [],
    bookmarks:[],
    sortFilterType: 'latest',
    isLoading: false
}